// Owner-mobile locale persistence. Independent of desktop's `niceloop_locale`
// key and of `user.Locale` — owner-mobile language is driven ONLY by the
// in-app toggle (Account tab) + this localStorage entry. Defaults to 'en'.

export const OWNER_MOBILE_LOCALE_KEY = 'owner_mobile_locale';

export type OwnerLocale = 'th' | 'en';

export function getOwnerLocale(): OwnerLocale {
  if (typeof localStorage === 'undefined') return 'en';
  try {
    const saved = localStorage.getItem(OWNER_MOBILE_LOCALE_KEY);
    if (saved === 'th' || saved === 'en') return saved;
  } catch (e) {
    /* ignore */
  }
  return 'en';
}

export function setOwnerLocale(code: OwnerLocale): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(OWNER_MOBILE_LOCALE_KEY, code);
  } catch (e) {
    /* ignore */
  }
}
